import { UIMessage } from '@ai-sdk/react';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { I18nNamespace } from '~/common/types';

import { fileAttachmentMessageHandler } from './ChatUserFileAttachmentMessage.handler';

export const useChatUserFileAttachmentMessage = (message: UIMessage) => {
  const { t } = useTranslation(I18nNamespace.intake, { keyPrefix: 'ChatUserFileAttachmentMessage' });

  const parsedData = useMemo(() => fileAttachmentMessageHandler.parseParts(message.parts), [message.parts]);

  return {
    ...parsedData,
    content: parsedData.content || t('defaultMessage'),
  };
};
